import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import Renderable from '../../../Component/Renderable';
import AnimationClip from '../AnimationClip';

export class ChestShadowJump extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        const renderable: Renderable = gameObject.getComponent(Renderable);

        const anticipationTween = this.getTween(transform.scale);
        const increaseTween = this.getTween(transform.scale);
        const decreaseTween = this.getTween(transform.scale);

        const fadeInTween = this.getTween(renderable);
        const fadeOutTween = this.getTween(renderable);

        anticipationTween.to({ x: 1.0, y: 0.3 }, 100);
        increaseTween.to({ x: 1.1, y: 0.6 }, 400).easing(Easing.Quadratic.Out);
        decreaseTween.to({ x: 1.0, y: 0.5 }, 600).easing(Easing.Bounce.Out);
        anticipationTween.chain(increaseTween);
        increaseTween.chain(decreaseTween);
        decreaseTween.chain(anticipationTween);

        fadeInTween.to({ alpha: 0.1 }, 400).easing(Easing.Quadratic.Out);
        fadeOutTween.to({ alpha: 0.2 }, 600).easing(Easing.Bounce.Out);
        fadeInTween.chain(fadeOutTween);
        fadeOutTween.chain(fadeInTween);

        anticipationTween.delay(1400).start(this.elapsedTime);

        fadeInTween.delay(1500).start(this.elapsedTime);

        while (true) yield;
    }
}
